
import { Component } from '@angular/core';
import { AlertController, NavController, NavParams } from 'ionic-angular';
import { Globals } from '../../../../globals';
import { getCurrencySymbol } from '@angular/common';
import { IngredientsServices } from "../../services";
import { StaticsServices } from '../../../services/statics';
import { TranslateService } from '@ngx-translate/core';
import { StockListPage } from '../../../stock/stock-list/stock-list';

/**
 * Generated class for the ProductCreateFoodcostPricePage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
  selector: 'page-ingredient-create-foodcost-price',
  templateUrl: 'ingredient-create-foodcost-price.html',
})
export class IngredientCreateFoodcostPricePage {

  // pvp: number = 0;
  // pvp2: number = 0;
  // pvp3: number = 0;
  // pvp_supplement: number = 0;
  // pvp_combo_extra: number = 0;
  // pvp_takeaway: number = 0;
  update_state: boolean = false;
  ingredient_uid: string;
  ingredient_name: string;
  _currency: any;
  ingredient: any;
  ingredient_tax: number = this.globals.RESTAURANT_TAX;
  show_alert: boolean = true;
  ean: string = "";

  constructor(public navCtrl: NavController,
    public navParams: NavParams,
    public globals: Globals,
    public IngredientsServices: IngredientsServices ,
    public staticsServices: StaticsServices,
    public translate: TranslateService,
    private alertCtrl: AlertController,) {

    this.ingredient_uid = this.navParams.get('ingredient_uid');
    this.update_state = this.navParams.get('update_state');
    this.ingredient_name = this.navParams.get('ingredient_name');
    this.ingredient = this.navParams.get('ingredient') || {};

    if (this.ingredient.tax) {
      this.ingredient_tax = this.ingredient.tax;
    }

    if (this.update_state) {//If update is true

      this.ean = this.navParams.get('ean');
    } else {

      this.ean = "";
    }

    this._currency = getCurrencySymbol(this.globals.user_currency, 'narrow', 'es'); //Get user current symbol
  }

  ionViewCanLeave(): Promise<void> {
    return new Promise((resolve, reject) => {
      //Si el show_alert es true i no estem fen un update al plat
      if (this.show_alert && !this.update_state) {
        let alert = this.alertCtrl.create({
          title: this.translate.instant('general-atencion'),
          message: this.translate.instant('general-salir-proceso-creacion'),
          subTitle: this.translate.instant('general-se-eliminara-elemento'),
          buttons: [
            {
              text: this.translate.instant('general-no'),
              role: 'cancel',
              handler: () => {
                this.globals.side_menu_active = 'stock';
                reject();
              },
            },
            {
              text: this.translate.instant('general-si'),
              handler: () => {
                this.IngredientsServices.afs.collection('ingredients').doc(this.ingredient_uid).delete();
                resolve();
                this.navCtrl.setRoot(StockListPage);
              },
            },
          ],
        });
        alert.present();
      } else {
        resolve();
      }
    });
  }

  update() {
    this.show_alert = false;
    //Si alguno de los precios es null o undefined, lo ponemos en 0
    // if (this.pvp == undefined || this.pvp == null) {
    //   this.pvp = 0;
    // }
    // if (this.pvp2 == undefined || this.pvp2 == null) {
    //   this.pvp2 = 0;
    // }
    // if (this.pvp3 == undefined || this.pvp3 == null) {
    //   this.pvp3 = 0;
    // }
    // if (this.pvp_supplement == undefined || this.pvp_supplement == null) {
    //   this.pvp_supplement = 0;
    // }
    // if (this.pvp_combo_extra == undefined || this.pvp_combo_extra == null) {
    //   this.pvp_combo_extra = 0;
    // }
    // if (this.pvp_takeaway == undefined || this.pvp_takeaway == null) {
    //   this.pvp_takeaway = 0;
    // }
    if (this.ean == undefined || this.ean == null) {
      this.ean = "";
    }


    this.IngredientsServices.afs.collection('ingredients').doc(this.ingredient_uid).update({ //save new price of product
      // 'pvp': this.pvp,
      // 'pvp2': this.pvp2,
      // 'pvp3': this.pvp3,
      // 'pvp_supplement': this.pvp_supplement,
      // 'pvp_combo_extra': this.pvp_combo_extra,
      // 'pvp_takeaway': this.pvp_takeaway,
      // 'tax': this.product_tax,
      'ean': this.ean,
      'updated_at': new Date(),
      'updated_user': this.globals.user_name
    }).then(() => {
      //this.globals.GAtrackView('Products', 'Products - Name - Update', this.globals.restaurant.email, 'Create/Update', 'Update name', 'Products', this.form.value.name);
      //dataset
      if (this.update_state) {
        this.sendData();
        this.staticsServices.changeStateStaticWait(true);
        this.navCtrl.pop();
      } 

    });
  }
  sendData() {
    // this.globals.dataSet('pvp', this.pvp, '', this.pvp);//Send product pvp data
    // this.globals.dataSet('pvp2', this.pvp2, '', this.pvp2);//Send product pvp2 data
    // this.globals.dataSet('pvp3', this.pvp3, '', this.pvp3);//Send product pvp3 data
    // this.globals.dataSet('pvp_supplement', this.pvp_supplement, '', this.pvp_supplement);//Send product pvp_supplement data
    // this.globals.dataSet('pvp_combo_extra', this.pvp_combo_extra, '', this.pvp_combo_extra);//Send product pvp_combo_extra data
    // this.globals.dataSet('pvp_takeaway', this.pvp_takeaway, '', this.pvp_takeaway);//Send product pvp_takeaway data
    // this.globals.dataSet('product_tax', this.product_tax, '', this.product_tax);//Send product product_tax data
    this.globals.dataSet('product_ean', this.ean, '', this.ean);//Send product product_ean data
  }

  inputPrice() {
    if (this.globals.so_mobile) {
      let cssClasses = {
        'input-group': true,
        'w-110': true,
        'w-150': false
      }
      return cssClasses;
    } else {
      let cssClasses = {
        'input-group': true,
        'w-150': true,
        'w-110': false
      }
      return cssClasses;
    }
  }

  profitFoodCost(price, _foodcost, _parts, _type) {
    var foodcost = (_foodcost / _parts) * _type
    //Quitamos el tax del precio
    price = this.globals.createSubTotal(price, this.globals.RESTAURANT_TAX);
    return 100 - this.globals.regla3(price, foodcost);
  }
}



// WEBPACK FOOTER //
// ./src/pages/ingredients/ingredient-create/ingredient-create-foodcost-price/ingredient-create-foodcost-price.ts